import firebase from './firebase';
import "firebase/storage";
const storage = firebase.storage();
export { storage};